import type React from 'react';

import { Logo } from '@change/ds-core-ui/Logo';

import { parseHtml } from '@change-corgi/core-react/html';

import { C } from '../ActionAlertEmailPreview/styles';

import { ContentBlockItem } from './ContentBlockItem';
import type { EditorialMembershipPreviewData } from './types';

export type { EditorialMembershipPreviewData } from './types';

// Template reference: https://github.com/change/comms_templates/tree/main/channels/email/templates/aa_editorial/sunrise
// (aa_membership_ask uses the same template structure)
export const EditorialMembershipEmailPreview: React.FC<{ data: EditorialMembershipPreviewData }> = ({ data }) => {
	const firstCtaIndex = (data.contentBlocks ?? []).findIndex((b) => b.buttonLink);

	return (
		<div style={{ backgroundColor: C.bodyBg, padding: 16, fontFamily: C.font, color: C.text }}>
			{/* Restore paragraph spacing reset by Tailwind preflight */}
			<style>
				{'.em-email-preview p { margin-bottom: 0.75em; } .em-email-preview p:last-child { margin-bottom: 0; }'}
			</style>
			<div
				style={{
					maxWidth: C.innerWidth,
					margin: '0 auto',
					backgroundColor: C.white,
					borderRadius: 4,
					overflow: 'hidden',
				}}
			>
				<div style={{ padding: '20px 24px', textAlign: 'center' }}>
					<Logo color="primary" size="medium" variant="logo" />
				</div>
				<hr style={{ border: 'none', borderTop: `2px solid ${C.border}`, margin: '0 24px' }} />
				<div className="em-email-preview" style={{ padding: 24 }}>
					{data.blurb && (
						<>
							<div style={{ fontSize: 14, lineHeight: 1.6, marginBottom: 16 }}>{parseHtml(data.blurb)}</div>
							<div style={{ marginBottom: 12 }} />
						</>
					)}
					{(data.contentBlocks ?? []).map((block, i) => (
						<div key={i} style={{ marginBottom: 12 }}>
							<ContentBlockItem block={block} isFirstCta={i === firstCtaIndex} />
						</div>
					))}
					{data.endParagraph && (
						<div style={{ fontSize: 14, lineHeight: 1.6, marginTop: 12 }}>{parseHtml(data.endParagraph)}</div>
					)}
				</div>
				<div style={{ padding: '16px 24px', borderTop: `1px solid ${C.border}`, textAlign: 'center' }}>
					<p style={{ fontSize: 12, color: C.muted, margin: 0 }}>
						Change.org · 548 Market St #29993, San Francisco, CA 94104
					</p>
				</div>
			</div>
		</div>
	);
};
